import React, { useEffect, useRef } from 'react';
import { MdClose } from 'react-icons/md';
import Txt from 'components/atoms/Txt/Txt';
import SocialShareButtons from '../SocialShareButtons/SocialShareButtons';
import { getAllowSocialMedia } from '../../../utils/cookieConsent';
import { useSocialShare } from '../../../hooks/useSocialShare';
import classes from './SocialSharePopover.module.scss';

export interface SocialSharePopoverProps {
  isOpen: boolean;
  onClose: () => void;
  type?: 'offer' | 'balance' | 'surveyComplete' | 'noTemplate';
  copyUrlOnly?: boolean;
  offer?: {
    title: string;
    url: string;
    paysReward: boolean;
    rewardLabel: string;
    advertiser: { name: string };
  };
  balance?: string;
  surveyComplete?: { amount: string };
  shareInfo?: {
    title?: string | null;
    description: string;
    url: string;
    imageUrl: string;
  };
}

const SocialSharePopover: React.FC<SocialSharePopoverProps> = (props) => {
  const { copyUrlOnly } = props;
  const allowSocialMedia = getAllowSocialMedia();
  const { shareData, tenant } = useSocialShare(props);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!props.isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
        props.onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props.isOpen, props.onClose]);

  if (!props.isOpen) return null;

  const { description, url } = shareData;

  return (
    <div className={classes.modalPopover} ref={popoverRef}>
      <Txt className={classes.title}>Share</Txt>
      {allowSocialMedia ? (
        <SocialShareButtons
          url={url}
          description={description}
          className={classes.icons}
          type={props.type}
          copyUrlOnly={copyUrlOnly}
        />
      ) : (
        <SocialShareButtons
          url={url}
          description={description}
          className={classes.icons}
          type={props.type}
          copyUrlOnly={copyUrlOnly}
          useDirectUrls={true}
          tenantConfig={tenant}
        />
      )}
      <button className={classes.closeButton} onClick={props.onClose} aria-label="Close">
        <MdClose />
      </button>
    </div>
  );
};

export default SocialSharePopover;
